var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jackisa"},[_c('h1',[_vm._v("Jack & Isa")]),_c('div',[_vm._v(_vm._s(_vm.timeSince))]),_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }